export default __webpack_public_path__ + "static/media/driver.145fc4be.svg";